import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate, dvUpdate, dvDelete } from '../api/dataverseClient';
import { Goal, GoalTask } from '../types';

const GOAL_FIELDS = [
  'dagrun_pm_goalid','dagrun_pm_name','dagrun_pm_description','dagrun_pm_goaltype',
  'dagrun_pm_status','dagrun_pm_ownerid','dagrun_pm_ownername','dagrun_pm_duedate',
  'dagrun_pm_targetvalue','dagrun_pm_currentvalue','dagrun_pm_unitlabel',
  'dagrun_pm_sortorder','dagrun_pm_clientvisible','_dagrun_pm_projectid_value',
];

export async function getProjectGoals(pca: IPublicClientApplication, projectId: string): Promise<Goal[]> {
  return dvList<Goal>(pca, 'dagrun_pm_goals', {
    select: GOAL_FIELDS,
    filter: `_dagrun_pm_projectid_value eq ${projectId}`,
    orderby: 'dagrun_pm_sortorder asc,dagrun_pm_duedate asc',
  });
}

export async function createGoal(
  pca: IPublicClientApplication,
  projectId: string,
  data: Partial<Goal> & { dagrun_pm_name: string; dagrun_pm_goaltype: number },
): Promise<string> {
  const body: Record<string, unknown> = {
    dagrun_pm_name: data.dagrun_pm_name,
    dagrun_pm_goaltype: data.dagrun_pm_goaltype,
    dagrun_pm_status: data.dagrun_pm_status ?? 100000000,
    dagrun_pm_ownername: data.dagrun_pm_ownername ?? null,
    dagrun_pm_duedate: data.dagrun_pm_duedate ?? null,
    dagrun_pm_targetvalue: data.dagrun_pm_targetvalue ?? null,
    dagrun_pm_currentvalue: data.dagrun_pm_currentvalue ?? 0,
    dagrun_pm_unitlabel: data.dagrun_pm_unitlabel ?? null,
    dagrun_pm_sortorder: data.dagrun_pm_sortorder ?? 0,
    dagrun_pm_clientvisible: data.dagrun_pm_clientvisible ?? false,
    'dagrun_pm_projectid@odata.bind': `/dagrun_pm_projects(${projectId})`,
  };
  return dvCreate(pca, 'dagrun_pm_goals', body);
}

export async function updateGoal(
  pca: IPublicClientApplication,
  goalId: string,
  patch: Record<string, unknown>,
): Promise<void> {
  return dvUpdate(pca, 'dagrun_pm_goals', goalId, patch);
}

export async function getGoalTasks(pca: IPublicClientApplication, goalId: string): Promise<GoalTask[]> {
  return dvList<GoalTask>(pca, 'dagrun_pm_goaltasks', {
    select: ['dagrun_pm_goaltaskid','dagrun_pm_name','dagrun_pm_addedby','dagrun_pm_addedon','_dagrun_pm_goalid_value','_dagrun_pm_taskid_value'],
    filter: `_dagrun_pm_goalid_value eq ${goalId}`,
  });
}

export async function linkTaskToGoal(
  pca: IPublicClientApplication,
  goalId: string,
  taskId: string,
): Promise<string> {
  return dvCreate(pca, 'dagrun_pm_goaltasks', {
    dagrun_pm_name: `Goal-Task link`,
    dagrun_pm_addedon: new Date().toISOString(),
    'dagrun_pm_goalid@odata.bind': `/dagrun_pm_goals(${goalId})`,
    'dagrun_pm_taskid@odata.bind': `/dagrun_pm_tasks(${taskId})`,
  });
}

export async function unlinkTaskFromGoal(pca: IPublicClientApplication, goalTaskId: string): Promise<void> {
  return dvDelete(pca, 'dagrun_pm_goaltasks', goalTaskId);
}
